module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-01-image-04.2b0f7739.png";